import React, { Component } from "react";
import OnDemandClassDetails from '../home/OnDemandClassDetails';
import ClassFilters from '../home/ClassFilters';
import { bookmarkClass } from  '../../utils/bookmarkClass';
import classnames from "classnames";
import { openOnDemandClass } from  '../../utils/openOnDemandClass';
import { openLiveClass } from  '../../utils/openLiveClass';
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class MarketplaceOnDemand extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		chosenInterest: (localStorage.getItem('onDemandInterest') && JSON.parse(localStorage.getItem('onDemandInterest')) && JSON.parse(localStorage.getItem('onDemandInterest')).length > 0) ? JSON.parse(localStorage.getItem('onDemandInterest')) : [],
		classInterests: [],
		allClasses: [],
		classesByInterest: [],
		sortOptions: ['Most Recent Classes', 'Popular Classes', 'Oldest Classes'],
		chosenSort: 'Most Recent Classes',
		isOpenSort: false,
		classInfo: {},
		durationsFilter: ['5', '10', '15', '20', '30', '45', '60', '60+'],
		chosenDurationFilter: [],
		instructorsFilter: [],
		chosenInstructrosFilter: [],
		chosenInstructrosDataFilter: [],
		advancedClassFilter: false,
		attendedClassFilter: false,
		pageCount: 0,
		onDemandClassesLength: 0,
		onDemandClassesTotalLength: 0,
		hostArrayIds: [],
		isLoadedClasses: false,
		subCategoryFilter: [],
		chosenSubCategoryFilter: [],
		chosenSubCategoryDataFilter: [],
		isLoadedAllClasses: false,
		currentUserData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
		musicFilters: [],
		chosenMusicFilters: [],
		chosenMusicData: []
	}
	
	this.bookmarkClass = bookmarkClass.bind(this);
	this.openOnDemandClass = openOnDemandClass.bind(this);
	this.openLiveClass = openLiveClass.bind(this);
	this.refDetails = React.createRef();
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
	
	if ( this.state.currentUserData.showLiveAndOnDemand )
		{
			this.getOnDemandClasses(true, false);
		}
	
	if ( this.props.parentComponent == 'mainPage' )
		{ 
			if ( this.state.currentUserData.showLiveAndOnDemand )
				{
					this.getOnDemandHosts(); 
					this.getOnDemandMusic(); 
				}
		}
}

getOnDemandClasses=(isNewInterest?, runLoader?)=>{
	var sortOption = 0;
	if ( this.state.chosenSort === 'Most Recent Classes' ) { sortOption = 1; }
	if ( this.state.chosenSort === 'Popular Classes' ) { sortOption = 2; }
	if ( this.state.chosenSort === 'Oldest Classes' ) { sortOption = 3; }
	var postData = {
			sortOption: sortOption,
			pageCount: this.state.pageCount, 
			chosenInterest: this.state.chosenInterest,
			chosenDurationFilter: this.state.chosenDurationFilter,
			chosenInstructrosFilter: this.state.chosenInstructrosFilter,
			chosenSubCategoryFilter: this.state.chosenSubCategoryFilter,
			advancedClassFilter: this.state.advancedClassFilter,
			attendedClassFilter: this.state.attendedClassFilter,
			chosenMusicFilters: this.state.chosenMusicFilters
		};
		
	if ( this.props.parentComponent == 'bookmarkClasses' )
		{
			postData['onlyBookmark'] = 1;
		}
	
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	if ( runLoader )
		{
			this.props.updateStateFromChild({showLoader: true});
		}
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getOnDemandClasses', postData).then(res => {
		var mainResponse = res.data.responseData;
		if ( runLoader )
			{
				this.props.updateStateFromChild({showLoader: false});
			}
		let tempAllClasses = this.state.allClasses;
		if ( isNewInterest )
			{
				tempAllClasses = [];
			}
			
		let finalAllClasses = tempAllClasses.concat(mainResponse.onDemandClasses);
		
		let tempClassInterests = mainResponse.classInterests;
		let tempClassInterestSubcategories = mainResponse.classSubcategories;
			
		var isLoadedAll = false;
		if ( mainResponse.onDemandClasses.length >= mainResponse.onDemandClassesTotalLength )
			{
				isLoadedAll = true;
			}
		
		localStorage.setItem('onDemandInterest', JSON.stringify(mainResponse.interestFilterArray));
		this.setState({
			classInterests: tempClassInterests,
			allClasses: finalAllClasses,
			onDemandClassesLength: finalAllClasses.length,
			onDemandClassesTotalLength: mainResponse.onDemandClassesTotalLength,
			isLoadedClasses: true,
			chosenInterest: mainResponse.interestFilterArray,
			isLoadedAllClasses: isLoadedAll,
			subCategoryFilter: tempClassInterestSubcategories
		}, () => {this.setClassesByInterest(this.state.chosenInterest)});
	}).catch(err =>{
		if ( runLoader )
			{
				this.props.updateStateFromChild({showLoader: false});
			}
	});
}

getOnDemandHosts=()=>{
	
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getOnDemandHosts').then(res => {
		this.setState({instructorsFilter: res.data.responseData});
	}).catch(err =>{ });
}

getOnDemandMusic=()=>{
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getOnDemandMusic').then(res => {
		this.setState({musicFilters: res.data.responseData});
	}).catch(err =>{ });
}

setClassesByInterest=(interest)=>{
	var allClasses = this.state.allClasses;
	var classByInterest = [];
	let allFoundArray = [];
	for ( var z = 0; z < allClasses.length; z++ )
		{
			var itemClass = allClasses[z];
			if ( itemClass.interestIds == null ) { itemClass.interestIds = "0"; }
				
			if ( itemClass.interestIds )
				{
					let find = false;
					if ( interest.length > 0 )
						{
							for (let i=0; i<interest.length; i++)
								{
									if ( itemClass.interestIds.indexOf(interest[i]) > -1 )
										{
											find = true;
										}
								}
						}
					else
						{
							find = true;
						}
					if (find || itemClass.priorityOrder )
						{
							classByInterest.push(itemClass);
						}
				}
				
			if ( this.props.parentComponent == 'bookmarkClasses' )
				{
					
					allFoundArray.push(allClasses[z]);
				}				
				
		}
	if ( this.props.parentComponent == 'bookmarkClasses' )
		{
			classByInterest = allFoundArray;
		}		
	this.setState({classesByInterest: classByInterest})
}

changeInterest=(interestId)=>{
	let tempChosenInterest = this.state.chosenInterest;
	if ( tempChosenInterest.indexOf(interestId) > -1 ) { return false; }
	tempChosenInterest = [];
	tempChosenInterest.push(interestId);
	this.setState({
		chosenInterest: tempChosenInterest,
		pageCount: 0,
		chosenSubCategoryFilter: [],
		chosenSubCategoryDataFilter: []
	}, ()=> {this.getOnDemandClasses(true, true);});
}

openCloseSort=()=>{
	var isOpen = this.state.isOpenSort;
	isOpen = !isOpen;
	this.setState({isOpenSort: isOpen});
}

preventDef=(e)=>{
	e.preventDefault();
	e.stopPropagation();
}

changeSort=(sort)=>{
	if ( !this.state.isLoadedAllClasses )
		{
			this.setState({
				chosenSort: sort, 
				isOpenSort: false,
				pageCount: 0
			}, () => this.getOnDemandClasses(true, true));
		}
	else
		{
			this.setState({
				chosenSort: sort, 
				isOpenSort: false,
			}, () => this.sortClasses(sort));
		}
}

sortClasses=(opt)=>{
	var arrayClasses = this.state.classesByInterest;
	
	if ( opt == 'Most Recent Classes' )
		{
			arrayClasses.sort(function(a, b){ 
				if ( new Date(a.createdAt) > new Date(b.createdAt) ) { return -1; } 
				if ( new Date(a.createdAt) < new Date(b.createdAt) ) { return 1; } 
				return 0; 
			})
		}
		
	if ( opt == 'Popular Classes' )
		{
			arrayClasses.sort(function(a, b){ 
				if ( a.totalviews > b.totalviews ) { return -1; } 
				if ( a.totalviews < b.totalviews ) { return 1; } 
				return 0; 
			})
		}
		
	if ( opt == 'Oldest Classes' )
		{
			arrayClasses.sort(function(a, b){ 
				if ( new Date(a.createdAt) < new Date(b.createdAt) ) { return -1; } 
				if ( new Date(a.createdAt) > new Date(b.createdAt) ) { return 1; } 
				return 0; 
			})
		}
		
	this.setState({classesByInterest: arrayClasses});
}

loadMoreOnDemandSessions = ()=>{
	let tempPageCount = this.state.pageCount + 1;
	this.setState({pageCount: tempPageCount
	}, ()=>{this.getOnDemandClasses(false, true);});
}

openDetailOnDemand=(id)=>{
	var postData = {classId: id};
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getOnDemandClassDetails', postData).then(res => {
		this.setState({classInfo: res.data.responseData}, () => this.props.updateStateFromChild({isOpenDetailedClass: true, openedDemandId: id}));
		this.refDetails.current.updateClassDetails(res.data.responseData);
	}).catch(err =>{ });
}

setFilter=(type, fil)=>{
	if ( type == 'duration' ) 
		{
			var chosenDurations = this.state.chosenDurationFilter;
			
			if ( chosenDurations.indexOf(fil) == -1 )
				{
					chosenDurations.push(fil);
				}
			else
				{
					var indexOfDur = chosenDurations.indexOf(fil);
					chosenDurations.splice(indexOfDur, 1);
				}
			
			chosenDurations.sort(function(a, b){
				console.log('a', a);
				console.log('b', b);
				if ( a == '60+' ) { return 1 }
				if ( b == '60+' ) { return -1; }
				if(parseInt(a) < parseInt(b)) { return -1; }
				if(parseInt(a) > parseInt(b)) { return 1; }
				return 0;
			});
			
			this.setState({chosenDurationFilter: chosenDurations});
		}
		
	if ( type == 'instructor' )
		{
			var chosenHosts = this.state.chosenInstructrosFilter;
			var chosenHostsData = this.state.chosenInstructrosDataFilter;
			
			if ( chosenHosts.indexOf(fil.id) == -1 )
				{
					chosenHosts.push(fil.id);
					chosenHostsData.push(
							{
								'id': fil.id,
								'fullName': fil.firstName+' '+fil.lastName
							}
						);
				}
			else
				{
					var indexOf = chosenHosts.indexOf(fil.id);
					chosenHosts.splice(indexOf, 1);
					for ( let i=0; i<chosenHostsData.length; i++)
						{
							if ( chosenHostsData[i]['id'] == fil.id )
								{
									chosenHostsData.splice(i, 1);
								}
						}
				}
			
			chosenHostsData.sort(function(a, b){
				if(a.fullName < b.fullName) { return -1; }
				if(a.fullName > b.fullName) { return 1; }
				return 0;
			})
			
			this.setState({
					chosenInstructrosFilter: chosenHosts,
					chosenInstructrosDataFilter: chosenHostsData
				})
		}
	if ( type == 'subcategory' )
		{
			var chosenSubcategory = this.state.chosenSubCategoryFilter;
			var chosenSubcategoryData = this.state.chosenSubCategoryDataFilter;
			if ( chosenSubcategory.indexOf(fil.id) == -1 )
				{
					chosenSubcategory.push(fil.id);
					chosenSubcategoryData.push(fil.name);
				}
			else
				{
					var indexOfDur = chosenSubcategory.indexOf(fil.id);
					chosenSubcategory.splice(indexOfDur, 1);
					chosenSubcategoryData.splice(indexOfDur, 1);
				}
				
			this.setState({
					chosenSubCategoryFilter: chosenSubcategory,
					chosenSubCategoryDataFilter: chosenSubcategoryData
				});
		}
		
	if ( type == 'music' )
		{
			var chosenMusicFiltersVar = this.state.chosenMusicFilters;
			var chosenMusicDataVar = this.state.chosenMusicData;
			
			if ( chosenMusicFiltersVar.indexOf(fil.musicType) == -1 )
				{
					chosenMusicFiltersVar.push(fil.musicType);
					chosenMusicDataVar.push(fil);
				}
			else
				{
					var indexOfMusic = chosenMusicFiltersVar.indexOf(fil.musicType);
					chosenMusicFiltersVar.splice(indexOfMusic, 1);
					chosenMusicDataVar.splice(indexOfMusic, 1);
				}
				
			this.setState({
					chosenMusicFilters: chosenMusicFiltersVar,
					chosenMusicData: chosenMusicDataVar
				});
		}
}

updateStateFromChild=(state)=>{
	this.setState(state);
}

resetFilter=()=>{
	this.setState({chosenDurationFilter: [], chosenInstructrosFilter: [], chosenMusicData: [], chosenMusicFilters: [],chosenInstructrosDataFilter: [], chosenSubCategoryFilter: [], chosenSubCategoryDataFilter: [], advancedClassFilter: false, attendedClassFilter: false}, () => {this.applyFilters()});
}

applyFilters=()=>{
	this.getOnDemandClasses(true, true);
}

bookMarkClass=(e, item)=>{
	e.preventDefault();
	e.stopPropagation();
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	
	var mainthis = this;
	var statusClass = 1;
	if ( item.isBookmarked == 1 ) { statusClass = 0; }
	this.props.updateStateFromChild({showLoader: true});
	this.bookmarkClass(item.classId, 2, statusClass).then(function(res){
		mainthis.getOnDemandClasses(true, true);
	}, function (err) { 
		this.props.updateStateFromChild({showLoader: false});
		if ( err.response && err.response.data && err.response.data.errorData ) 
			{
				mainthis.props.showMainErrorPop(err.response.data.errorData); 
			}
	});
}

playClass=(e, id)=>{
	e.preventDefault();
	e.stopPropagation();
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	
	var mainthis = this;
	if ( this.props && this.props.parentComponent && this.props.parentComponent == 'bookmarkClasses' )
		{
			window['openOndemandFromBookmark'] = true;	
		}
	else 
		{
			window['openOndemandFromBookmark'] = false;	
		}
	
	localStorage.removeItem('groupClass');
	this.openLiveClass(id, true);
	
	/* this.openOnDemandClass(id).then(function(res){
		mainthis.props.history.push("/pre-screen");
	}, function (err) { mainthis.props.showMainErrorPop(err); }); */
}

  render() {
	 return (
		<div>
			<div className={classnames({'class_container': true, 'empty_state_component': (this.state.classesByInterest.length == 0 && this.props.parentComponent == 'bookmarkClasses')})}>
				<div className={( this.props.isOpenDetailedClass ? "d-none" : "" )}>
					{ this.props.parentComponent == 'mainPage' &&
						<div className="filter_interest_container">
							<div>
								{ this.state.classInterests.map((item, i) =>
									<div key={i} className={"filter_interest " + ( this.state.chosenInterest.indexOf(item.id) > -1 ? "active" : "" )} onClick={() => this.changeInterest(item.id)}>
										<div className="interest_icon" style={{ backgroundImage: "url("+item.image_icon+")"}}></div>
										<div className="interest_title">{item.name}</div>
									</div>
								)}
								<ClassFilters 
									durationsFilter={this.state.durationsFilter}
									chosenDurationFilter={this.state.chosenDurationFilter}
									instructorsFilter={this.state.instructorsFilter}
									chosenInstructrosFilter={this.state.chosenInstructrosFilter}
									chosenInstructrosDataFilter={this.state.chosenInstructrosDataFilter}
									advancedClassFilter={this.state.advancedClassFilter}
									attendedClassFilter={this.state.attendedClassFilter}
									setFilter={this.setFilter}
									resetFilter={this.resetFilter}
									applyFilters={this.applyFilters}
									updateStateFromChild={this.updateStateFromChild}
									subCategoryFilter = {this.state.subCategoryFilter}
									chosenSubCategoryFilter = {this.state.chosenSubCategoryFilter}
									chosenSubCategoryDataFilter = {this.state.chosenSubCategoryDataFilter}
									musicFilters = {this.state.musicFilters}
									chosenMusicFilters = {this.state.chosenMusicFilters}
									chosenMusicData = {this.state.chosenMusicData}
								>
								</ClassFilters>
							</div>
						</div>
					}
					<div className={classnames({'classes_container': true, 'classes_container_all': this.props.parentComponent == 'bookmarkClasses'})}>
						{ (this.props.parentComponent == 'mainPage' && this.state.classesByInterest.length > 0) &&
							<div className="sort_demand_content">
								<div className="sort_demand" onClick={this.openCloseSort}>
									<div className="sort_demand_title">{this.state.chosenSort}</div>
									<div className={"arrow_down_sort " + ( this.state.isOpenSort ? "active_arrow" : "" )}></div>
									{ this.state.isOpenSort &&
										<div className="sort_container" onClick={this.preventDef}>
											<div className="sort_title">Sort By</div>
											{ this.state.sortOptions.map((item, i) =>
												<div className={"sort_options " + ( this.state.chosenSort == item ? "active" : "" )} key={i} onClick={() => this.changeSort(item)}>{item}
													<div className="checked_sort"></div>
												</div>
											)}
										</div>
									}
								</div>
							</div>
						}
						<div className="classes_holder">
							{ this.state.classesByInterest.map((item, i) =>
								<div className={classnames({'class_content': true, 'demand_class_content': true})} key={i} onClick={() => this.openDetailOnDemand(item.classId)}>
									<div className="class_demand_image" style={{ backgroundImage: "url("+item.classImage+")"}}></div>
									<div className={classnames({'ondemand_class_content': true, 'ondemand_class_play': this.props.parentComponent == 'bookmarkClasses'})}>
										<div className="top_class_content">
											<div className={"class_icon " + ( item.isBookmarked == 1 ? "bookmarked_icon" : "" )} onClick={(e) => this.bookMarkClass(e, item)}></div>
											<div className="class_time">{Math.floor(item.classDuration / 60)} min</div>
											<div className="class_dot">&bull;</div>
											<div className="eye_views"></div>
											<div className="class_time">{item.totalviews}</div>
											<div className="class_interest">{item.interestTitles}</div>
										</div>
										<div className="class_name">{item.className}</div>
										<div className="bottom_class_content">
											<div className="instructor_avatar" style={{ backgroundImage: item.hostImage && item.hostImage.indexOf('.s3') > -1 ? "url("+item.hostImage+")" : "url(./images/user_avatar.svg)"}}></div>
											<div className="instructor_name">{item.hostFirstName} {item.hostLastName}</div>
										</div>
									</div>
									{ this.props.parentComponent == 'bookmarkClasses' &&
										<div className="buttons_class_content center_buttons">
											<div className="class_active_btn" onClick={(e) => this.playClass(e, item.classId)}>Start</div>
										</div>
									}
								</div>
							)}
							{ (this.state.onDemandClassesTotalLength > this.state.onDemandClassesLength && this.state.classesByInterest.length > 0) && 
								<div className="txt_cent_cont">
									<div className="loadMore" onClick={() => this.loadMoreOnDemandSessions()}>Load More</div>
								</div>
							}
						</div>
						{ this.state.classesByInterest.length == 0 && this.state.isLoadedClasses && this.props.parentComponent != 'bookmarkClasses' && 
							<div className="empty_state">No available On Demand classes.</div>
						}
					</div>
				</div>
				{ this.state.classesByInterest.length == 0 && this.state.isLoadedClasses && this.props.parentComponent == 'bookmarkClasses' && !this.props.isOpenDetailedClass &&
					<div className="empty_state">No available Bookmarked On Demand classes.</div>
				}
			</div>
			<div className={( !this.props.isOpenDetailedClass ? "d-none" : "" )}>
				<OnDemandClassDetails 
				failedPaymentStatus={(this.props && this.props.state ? this.props.state.failedPaymentStatus : false)}
				classInfo={this.state.classInfo} 
				getOnDemandClasses={this.getOnDemandClasses} 
				updateStateFromChild={this.updateStateFromChild} 
				history={this.props.history}
				openFrom={this.props.parentComponent}	
				ref={this.refDetails}></OnDemandClassDetails>
			</div>
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(MarketplaceOnDemand);
